import { useMutation } from '@tanstack/react-query';
import { QualificationQuestionsAnswers } from 'modules/data/domain';
import { ExpandedProfileData } from 'modules/first-start/selectors/moduleSelectors';
import { api } from 'services/api';
import { saveQualificationQuestionsAnswers } from 'shared/helpers';

export const useSetupProfileMutation = (
    profileData: ExpandedProfileData,
    disableNotifications: boolean,
    nextStep: () => void
) => {
    const setupProfile = async (
        params: {
            qualificationQuestionsAnswers?: QualificationQuestionsAnswers | null;
        } | void
    ) => {
        await api.profile.edit({
            firstName: profileData.firstName,
            lastName: profileData.lastName,
            skype: '',
            phone: profileData.phone || '',
            timeZoneForEmail: window.ApprovalMax.userTimeZone,
            qualificationQuestionAnswers: params?.qualificationQuestionsAnswers ?? undefined,
            ...(disableNotifications
                ? {
                      sendApprovalChangeNotifications: false,
                      sendCommentsNotifications: false,
                      sendWorkflowNotifications: false,
                      sendNewRequestsNotifications: false,
                      sendSummaryNotifications: false,
                  }
                : {}),
        });

        await api.profile.setPassword({
            timeZoneForEmail: window.ApprovalMax.userTimeZone,
            pwd: profileData.password,
        });

        saveQualificationQuestionsAnswers(params?.qualificationQuestionsAnswers);
    };

    return useMutation(setupProfile, {
        onSuccess: nextStep,
    });
};
